// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3BxXX","content":"Consent_content__bg67i","footer":"Consent_footer__1eN_5"};